import { Point } from '@view-model/models/common/basic';
import type { RectShape } from '@model-framework/shape';
import { CONTAINER_MARGIN } from '../constants';

type Props = {
  position: Point;
  containerRectShape: RectShape;
  className: string;
  strokeWidth?: number;
};

export const StickyZoneContainerBorder: React.FC<Props> = ({
  position,
  containerRectShape,
  className,
  strokeWidth = 8,
}: Props) => {
  return (
    <g
      transform={Point.fromPosition({
        x: position.x - CONTAINER_MARGIN,
        y: position.y - CONTAINER_MARGIN,
      }).toSVGTranslate()}
    >
      {containerRectShape.render({
        pointerEvents: 'none',
        strokeWidth,
        className,
      })}
    </g>
  );
};
